<script setup>
import { defineComponent, h } from 'vue';
import { useI18n } from 'vue-i18n';
import { MoonIcon, SunIcon } from '@heroicons/vue/outline';

const { locale } = useI18n();
watch(locale, () => {
  const language = useCookie('user-lang');
  language.value = locale.value;
  console.log('locale', locale.value);
});

const colorMode = useColorMode();

const navigation = {
  support: [
    { name: 'blog', href: '/blog' },
    { name: 'documentation', href: 'https://docs.mintgarden.io/', target: '_blank' },
    {
      name: 'legalnotice',
      href: '/legal-notice',
    },
  ],
  developers: [
    {
      name: 'status',
      href: 'https://status.mintgarden.io/',
      target: '_blank',
    },
    { name: 'api', href: 'https://api.mintgarden.io/docs', target: '_blank' },
    // { name: 'About', href: '/about' },
  ],
  legal: [
    { name: 'Terms and Conditions', href: '/terms' },
    { name: 'Privacy Policy', href: '/privacy' },
  ],
  social: [
    {
      name: 'Twitter',
      href: 'https://twitter.com/mintgarden_io',
      icon: defineComponent({
        render: () =>
          h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
            h('path', {
              d: 'M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84',
            }),
          ]),
      }),
    },
    {
      name: 'GitHub',
      href: 'https://github.com/mintgarden-io',
      icon: defineComponent({
        render: () =>
          h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
            h('path', {
              'fill-rule': 'evenodd',
              d: 'M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z',
              'clip-rule': 'evenodd',
            }),
          ]),
      }),
    },
    {
      name: 'Discord',
      href: 'https://discord.gg/c2uMj2m4da',
      icon: defineComponent({
        render: () =>
          h('svg', { fill: 'currentColor', viewBox: '0 0 71 55' }, [
            h('path', {
              'fill-rule': 'evenodd',
              d: 'M60.1045 4.8978C55.5792 2.8214 50.7265 1.2916 45.6527 0.41542C45.5603 0.39851 45.468 0.440769 45.4204 0.525289C44.7963 1.6353 44.105 3.0834 43.6209 4.2216C38.1637 3.4046 32.7345 3.4046 27.3892 4.2216C26.905 3.0581 26.1886 1.6353 25.5617 0.525289C25.5141 0.443589 25.4218 0.40133 25.3294 0.41542C20.2584 1.2888 15.4057 2.8186 10.8776 4.8978C10.8384 4.9147 10.8048 4.9429 10.7825 4.9795C1.57795 18.7309 -0.943561 32.1443 0.293408 45.3914C0.299005 45.4562 0.335386 45.5182 0.385761 45.5576C6.45866 50.0174 12.3413 52.7249 18.1147 54.5195C18.2071 54.5477 18.305 54.5139 18.3638 54.4378C19.7295 52.5728 20.9469 50.6063 21.9907 48.5383C22.0523 48.4172 21.9935 48.2735 21.8676 48.2256C19.9366 47.4931 18.0979 46.6 16.3292 45.5858C16.1893 45.5041 16.1781 45.304 16.3068 45.2082C16.679 44.9293 17.0513 44.6391 17.4067 44.3461C17.471 44.2926 17.5606 44.2813 17.6362 44.3151C29.2558 49.6202 41.8354 49.6202 53.3179 44.3151C53.3935 44.2785 53.4831 44.2898 53.5502 44.3433C53.9057 44.6363 54.2779 44.9293 54.6529 45.2082C54.7816 45.304 54.7732 45.5041 54.6333 45.5858C52.8646 46.6197 51.0259 47.4931 49.0921 48.2228C48.9662 48.2707 48.9102 48.4172 48.9718 48.5383C50.038 50.6034 51.2554 52.5699 52.5959 54.435C52.6519 54.5139 52.7526 54.5477 52.845 54.5195C58.6464 52.7249 64.529 50.0174 70.6019 45.5576C70.6551 45.5182 70.6887 45.459 70.6943 45.3942C72.1747 30.0791 68.2147 16.7757 60.1968 4.9823C60.1772 4.9429 60.1437 4.9147 60.1045 4.8978ZM23.7259 37.3253C20.2276 37.3253 17.3451 34.1136 17.3451 30.1693C17.3451 26.225 20.1717 23.0133 23.7259 23.0133C27.308 23.0133 30.1626 26.2532 30.1066 30.1693C30.1066 34.1136 27.28 37.3253 23.7259 37.3253ZM47.3178 37.3253C43.8196 37.3253 40.9371 34.1136 40.9371 30.1693C40.9371 26.225 43.7636 23.0133 47.3178 23.0133C50.9 23.0133 53.7545 26.2532 53.6986 30.1693C53.6986 34.1136 50.9 37.3253 47.3178 37.3253Z',
              'clip-rule': 'evenodd',
            }),
          ]),
      }),
    },
  ],
};
</script>
<template>
  <footer aria-labelledby="footer-heading" class="bg-white pb-8 pt-32 dark:bg-black lg:pt-64">
    <h2 id="footer-heading" class="sr-only">Footer</h2>
    <Container>
      <div class="md:grid md:grid-cols-3 md:gap-8">
        <div class="space-y-8 md:col-span-1">
          <img class="image-gray-500 h-10" src="/mintgarden-logo.svg" alt="MintGarden" />
          <p class="text-base text-neutral-500 dark:text-neutral-400">{{ $t('footer.description') }}</p>
          <div class="flex space-x-6">
            <a
              v-for="item in navigation.social"
              :key="item.name"
              :href="item.href"
              class="text-neutral-400 hover:text-neutral-500 dark:text-neutral-400 dark:text-neutral-500"
            >
              <span class="sr-only">{{ item.name }}</span>
              <component :is="item.icon" class="h-6 w-6" aria-hidden="true" />
            </a>
          </div>
        </div>
        <div class="mt-12 md:col-span-2 md:mt-0">
          <div class="space-y-8 sm:grid sm:grid-cols-3 sm:gap-8 sm:space-y-0 xl:grid-cols-4">
            <div>
              <h3 class="text-sm font-semibold uppercase tracking-wider text-neutral-400 dark:text-neutral-500">
                {{ $t('footer.support') }}
              </h3>
              <ul role="list" class="mt-4 space-y-4">
                <li v-for="item in navigation.support" :key="item.name">
                  <NuxtLink
                    :to="item.href"
                    :target="item.target"
                    class="text-base text-neutral-500 hover:text-neutral-900 dark:text-neutral-400 hover:dark:text-neutral-50"
                  >
                    {{ $t(`footer.${item.name}`) }}
                  </NuxtLink>
                </li>
              </ul>
            </div>
            <div>
              <h3 class="text-sm font-semibold uppercase tracking-wider text-neutral-400 dark:text-neutral-500">
                {{ $t('footer.developers') }}
              </h3>
              <ul role="list" class="mt-4 space-y-4">
                <li v-for="item in navigation.developers" :key="item.name">
                  <NuxtLink
                    :to="item.href"
                    :target="item.target"
                    class="text-base text-neutral-500 hover:text-neutral-900 dark:text-neutral-400 hover:dark:text-neutral-50"
                  >
                    {{ $t(`footer.${item.name}`) }}
                  </NuxtLink>
                </li>
              </ul>
            </div>
            <div>
              <h3 class="text-sm font-semibold uppercase tracking-wider text-neutral-400 dark:text-neutral-500">
                Settings
              </h3>
              <form>
                <select
                  id="locale-select"
                  v-model="$i18n.locale"
                  class="mt-2 block w-full rounded-md border-0 bg-white py-1.5 pl-3 pr-10 text-neutral-900 ring-1 ring-inset ring-neutral-300 focus:ring-2 focus:ring-black dark:bg-black dark:text-neutral-50 dark:ring-neutral-600 sm:text-sm sm:leading-6"
                >
                  <option value="en">English</option>
                  <option value="zh">简体中文</option>
                </select>
              </form>
              <div class="mt-4">
                <button
                  class="group rounded-full bg-white px-4 py-2 shadow-lg shadow-neutral-800/5 ring-1 ring-neutral-900/5 backdrop-blur transition dark:bg-black/90 dark:bg-neutral-800/90 dark:ring-white/10 dark:hover:ring-white/20"
                  @click="colorMode.preference = colorMode.value === 'light' ? 'dark' : 'light'"
                >
                  <div class="hidden items-center gap-2 text-neutral-500 dark:flex dark:text-neutral-400">
                    <MoonIcon
                      class="mr hidden h-6 w-6 stroke-neutral-500 text-neutral-700 transition group-hover:stroke-neutral-400 dark:block dark:text-neutral-200"
                    />
                    Dark
                  </div>
                  <div class="flex items-center gap-2 text-neutral-500 dark:hidden dark:text-neutral-400">
                    <SunIcon
                      class="h-6 w-6 stroke-neutral-500 text-neutral-100 transition group-hover:stroke-neutral-600 dark:hidden dark:text-neutral-800"
                    />
                    Light
                  </div>
                </button>
              </div>
            </div>

            <!--            <div>-->
            <!--              <h3 class="text-sm font-semibold text-neutral-400 dark:text-neutral-500 tracking-wider uppercase">Legal</h3>-->
            <!--              <ul role="list" class="mt-4 space-y-4">-->
            <!--                <li v-for="item in navigation.legal" :key="item.name">-->
            <!--                  <NuxtLink :to="item.href" class="text-base text-neutral-500 dark:text-neutral-400 hover:text-neutral-900 dark:text-neutral-50">-->
            <!--                    {{ item.name }}-->
            <!--                  </NuxtLink>-->
            <!--                </li>-->
            <!--              </ul>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
      <div class="mt-12 border-t border-neutral-200 pt-8 dark:border-neutral-700">
        <p class="text-base text-neutral-400 dark:text-neutral-500 xl:text-center">
          &copy; {{ new Date().getFullYear() }} MintGarden. {{ $t('footer.allRightsReserved') }}
        </p>
      </div>
    </Container>
  </footer>
</template>
